// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { FieldProps } from '../../../types';
import Select from '../select';
import { range } from '../../../helpers';
import { getFormSettings } from '../../../store/formSettings/selectors';

type StateProps = {|
  dateOfBirthDay: string,
|};

type Props = StateProps & FieldProps;

const Days = ({
  dateOfBirthDay,
  input,
  meta: {
    touched,
    error,
  },
}: Props) => (
  <Select
    error={Boolean(touched && error)}
    {...input}
  >
    <option value="">{dateOfBirthDay}</option>
    {range(1, 32).map(dayOption => (
      <option value={dayOption} key={`birth_date_day_${dayOption}`}>{dayOption}</option>
    ))}
  </Select>
);

const mapStateToProps = (state): StateProps => ({
  dateOfBirthDay: getFormSettings(state).date_of_birth_day,
});

export default connect<any, FieldProps, StateProps, any, any, any>(mapStateToProps)(Days);
